import * as h2Api from '../h2Api'

export const FETCH_RECOMMENDATIONS = 'FETCH_RECOMMENDATIONS'

export const FETCH_ASSESSMENT_STATUS = 'FETCH_ASSESSMENT_STATUS'

export const FETCH_UPCOMING_EVENTS = 'FETCH_UPCOMING_EVENTS'

export const FETCH_COMBINED_INFO_FOR_PERSONAL_PROFILE_SCREEN =
  'FETCH_COMBINED_INFO_FOR_PERSONAL_PROFILE_SCREEN'

export const OPEN_OR_CLOSE_ACTIVATE_PUBLIC_PROFILE_DIALOG =
  'OPEN_OR_CLOSE_ACTIVATE_PUBLIC_PROFILE_DIALOG'

export const PROFILE_USERNAME_CHANGE_IN_DIALOG = 'PROFILE_USERNAME_CHANGE_IN_DIALOG'

export const ACTIVATE_PUBLIC_PROFILE = 'ACTIVATE_PUBLIC_PROFILE'

export const ADD_ASSESSMENT_SECTION = 'ADD_ASSESSMENT_SECTION'

export const PROFILE_SELECT_STEP = 'PROFILE_SELECT_STEP'

export const TOGGLE_SECTION_PUBLICATION = 'TOGGLE_SECTION_PUBLICATION'

export const RATE_ITEM = 'PERSONAL_PROFILE_RATE_ITEM'

export const togglePublication = s => dispatch => {
  const toPost = { toggleTo: !s.isPublished }

  dispatch(h2Api.post(s.toggleUrl, toPost)({ type: TOGGLE_SECTION_PUBLICATION }))
}

export const fetchRecommendations = () => dispatch => {
  return dispatch(
    h2Api.get('/occupations/recommendations')({ type: FETCH_RECOMMENDATIONS })
  )
}

export const rateItem = (itemType, itemId, rating) => dispatch => {
  return dispatch(
    h2Api.put(`/user/rate/${itemType}/${itemId}`, {
      rating
    })({ type: RATE_ITEM })
  )
}

export const fetchAssessmentStatus = () => {
  h2Api.get('/assessment/status')({ type: FETCH_ASSESSMENT_STATUS })
}

export const fetchUpcomingEvents = () =>
  h2Api.get('/user/calendar/upcoming')({ type: FETCH_UPCOMING_EVENTS })

export const addAssessmentSection = url => dispatch => {
  dispatch(h2Api.put(url)({ type: ADD_ASSESSMENT_SECTION }))
  dispatch(fetchRecommendations())
}

export const fetchCombinedInfoForPersonalProfileScreen = () =>
  h2Api.get('/user/combined')({ type: FETCH_COMBINED_INFO_FOR_PERSONAL_PROFILE_SCREEN })

export const openOrCloseActivatePublicProfileDialog = isOpened => dispatch =>
  dispatch({ type: OPEN_OR_CLOSE_ACTIVATE_PUBLIC_PROFILE_DIALOG, isOpened })

export const profileUserNameChangeInDialog = value => dispatch =>
  dispatch({ type: PROFILE_USERNAME_CHANGE_IN_DIALOG, value })

export const selectStep = step => dispatch =>
  dispatch({ type: PROFILE_SELECT_STEP, step })

export const activatePublicProfile = () => (dispatch, getState) => {
  const fieldVal = getState().personalProfile.profileUserNameInDialog

  dispatch(
    h2Api.put('/candidates/profile', {
      userName: fieldVal.name,
      summary: fieldVal.about
    })({ type: ACTIVATE_PUBLIC_PROFILE })
  ).then(() => {
    dispatch(openOrCloseActivatePublicProfileDialog(false))
  })
}
